<template>
  <div>
    <list
      row-key="ClassId"
      ref="list"
      unit="类别"
      :expand-all-row="true"
      :page="false"
      :get-data-func="getDataFunc"
      :delete-func="api.delete"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <el-table-column prop="ClassName" label="类别名称" />
        <el-table-column prop="Sort" label="排序" align="center" min-width="100" sortable="custom" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/ba/class").default,
      params: {
        ClassType: 6
      },
      sourceData: null,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list(params).then((res) => {
          this.sourceData = res.Data;
          let Data = this.$commonJs.toTreeData(res.Data, "ClassId");
          
          
          resolve({ Code: 0, Data });
        });
      });
    },
  },
};
</script>